// extracted by mini-css-extract-plugin
module.exports = {"order_product_item":"OrderProductItem_order_product_item__CSuhV","left":"OrderProductItem_left__ueLXL","right":"OrderProductItem_right__y9gqy"};